import { attr, Model } from 'redux-orm';
import { createAction, createLoadConst } from '../util';
import { addDerivedData } from './util/payALoanAudit';

export default class PayALoanAudit extends Model {
  static get modelName() {
    return 'PayALoanAudit';
  }

  static reducer({ type, data }, PayALoanAudit) {
    switch (type) {
      case LOAD.SUCCESS:
        PayALoanAudit.delete();
        if (data.response) {
          data.response.forEach((r) => PayALoanAudit.upsert(addDerivedData(r)));
        }
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      byAdminUserId: attr(),
      bySystemUser: attr(),
      byUserId: attr(),
      updUserId: attr(),
      updAdminUserId: attr(),
      updSysUser: attr(),
      changelog: attr(),
      id: attr(),
      logAt: attr(),
      logOp: attr(),
      insAt: attr(),
      insUpdateOp: attr(),
      schedId: attr(),
      time: attr(), // derived
      title: attr(), // derived
    };
  }
}

export const LOAD = createLoadConst(PayALoanAudit.modelName);
export const load = createAction(LOAD);
